import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
import { ZoomApiInterface } from '../types/event-interface';
export function useCheckZoomIntegration() {
  const $ = _c(7);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== user) {
    t1 = () => {
      if (user) {
        return `/api/dashboard/booking-calendar/zoom/integrations?timezone=${user.timezone}`;
      }
    };
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data,
    isLoading,
    mutate
  } = useSWR(t1, fetcher);
  const t2 = Boolean(data?.items.length);
  let t3;
  if ($[3] !== isLoading || $[4] !== mutate || $[5] !== t2) {
    t3 = {
      isZoomIntegrated: t2,
      isLoading,
      mutate
    };
    $[3] = isLoading;
    $[4] = mutate;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}